import type { Role } from '@/data'
import api from '.'

export interface RolePayload {
  name: string
  guard_name?: string
  permission_ids?: number[]
}

export async function createRole(payload: RolePayload): Promise<Role> {
  const res = await api.post('/', payload)
  return res.data.data
}
